import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Typeahead } from 'react-bootstrap-typeahead';

import { FormBox } from '../../../css';

const TypeaheadField = ({
  label,
  errors,
  touched,
  name,
  id,
  defaultVal,
  list,
  errorIcon,
  val,
  setFieldValue,
  setFieldTouched
}) => {
  const [multiple] = useState(false);
  const [selected, setSelected] = useState(
    list.filter(l => l.id === defaultVal)
  );
  const changeHandler = value => {
    setSelected(value);
    setFieldValue(value);
  };

  return (
    <FormBox>
      <div className="main-content-form-headers">
        <span>{label}</span>
      </div>
      <div
        style={{ position: 'relative' }}
        className={`input-container ${errors[name] && touched[name] ? 'error' : ''
          }`}
      >
        <Typeahead
          style={{ position: 'relative' }}
          id={id}
          labelKey={val}
          name={name}
          multiple={multiple}
          onChange={changeHandler}
          selected={selected}
          // onInputChange={onInputChange}
          onBlur={setFieldTouched}
          options={list}
        />
        <>
          <div className="error_messages">
            <span className="registration-error">{errors[name]}</span>
          </div>
          {errorIcon && (
            <div id="username_error_icon" className="error_messages_icon">
              <img src={errorIcon} alt="error_icon" />
            </div>
          )}
        </>
      </div>
    </FormBox>
  );
};

TypeaheadField.propTypes = {
  label: PropTypes.string.isRequired,
  errors: PropTypes.arrayOf(PropTypes.string),
  touched: PropTypes.arrayOf(PropTypes.bool),
  name: PropTypes.string.isRequired,
  id: PropTypes.number,
  defaultVal: PropTypes.string,
  errorIcon: PropTypes.string,
  list: PropTypes.arrayOf(PropTypes.any),
  val: PropTypes.string,
  setFieldValue: PropTypes.func.isRequired,
  setFieldTouched: PropTypes.func.isRequired
};

TypeaheadField.defaultProps = {
  errors: [],
  touched: [],
  id: null,
  defaultVal: null,
  errorIcon: null,
  list: [],
  val: null
};

export default TypeaheadField;
